import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.set-prototype-of.js";
import "core-js/modules/es.function.bind.js";
import "core-js/modules/es.object.get-prototype-of.js";
import "core-js/modules/es.reflect.construct.js";
import "core-js/modules/es.object.create.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.index-of.js";
import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import _pt from "prop-types";
var _excluded = ["id", "title", "content", "onClick", "imageSrc", "imageAlt", "expandableId", "actions", "isCollapsed", "className", "titleHeadingLevel", "elevation", "children", "spacing", "href", "custom"];
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.number.constructor.js";
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import * as React from 'react';
import classNames from 'classnames';
import { Button } from '@lmig/lmds-react-button';
import IconCaretDown from '@lmig/lmds-react-icons/dist/icons/CaretDown';
import "./card.css";
/**
 * @see [LMDS Card documentation and examples](https://designsystem.lmig.com/components/cards/code)
 *
 * API:
 *
 * @implements [CardProps](https://designsystem.lmig.com/components/cards/code#card-props)
 * @extends [HTMLButtonElement](https://microsoft.github.io/PowerBI-JavaScript/interfaces/_node_modules_typedoc_node_modules_typescript_lib_lib_dom_d_.htmlbuttonelement.html)
 * @extends [HTMLDivElement](https://microsoft.github.io/PowerBI-JavaScript/interfaces/_node_modules_typedoc_node_modules_typescript_lib_lib_dom_d_.htmldivelement.html)
 */
export var Card = /*#__PURE__*/function (_React$Component) {
  _inherits(Card, _React$Component);
  var _super = _createSuper(Card);
  function Card(props) {
    var _this;
    _classCallCheck(this, Card);
    _this = _super.call(this, props);
    _defineProperty(_assertThisInitialized(_this), "expandableCardRef", /*#__PURE__*/React.createRef());
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
    _defineProperty(_assertThisInitialized(_this), "handleButtonCollapseClick", function () {
      var _this$expandableCardR;
      var element = (_this$expandableCardR = _this.expandableCardRef) === null || _this$expandableCardR === void 0 ? void 0 : _this$expandableCardR.current;
      if (element) {
        var contentHeight = element.scrollHeight;
        // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
        var resetHeight = function resetHeight() {
          // remove "height" from the element's inline styles, so it can return to its initial value, likely height: auto
          element.style.height = null;
        };
        var collapsed = _this.state.collapsed;
        if (!collapsed) {
          // temporarily disable all css transitions
          var elementTransition = element.style.transition;
          element.style.transition = '';
          element.style.height = "".concat(contentHeight, "px");

          // on the next frame (as soon as the previous style change has taken effect),
          // explicitly set the element's height to its current pixel height, so we
          // aren't transitioning out of 'auto'
          requestAnimationFrame(function () {
            element.style.transition = elementTransition;

            // on the next frame (as soon as the previous style change has taken effect),
            // have the element transition to height: 0
            requestAnimationFrame(function () {
              element.style.height = '0px';
            });
          });
          _this.setState({
            collapsed: true
          });
        } else {
          element.style.height = "".concat(contentHeight, "px");

          // when the next css transition finishes (which should be the one we just triggered)
          element.addEventListener('transitionend', resetHeight, {
            once: true
          });
          _this.setState({
            collapsed: false
          });
        }
      }
    });
    _defineProperty(_assertThisInitialized(_this), "renderTitle", function () {
      var title = _this.props.title;
      // Workaround the typing to allow backward compatibility with type `string`
      // eslint-disable-next-line react/destructuring-assignment
      var Tag = _this.props.titleHeadingLevel || 'h2';
      return title ? /*#__PURE__*/React.createElement(Tag, {
        className: "lm-Card-title"
      }, title) : null;
    });
    _defineProperty(_assertThisInitialized(_this), "containerTag", function () {
      var _this$props = _this.props,
        href = _this$props.href,
        onClick = _this$props.onClick;
      var Tag = 'div';
      if (onClick) {
        Tag = 'button';
      } else if (href) {
        Tag = 'a';
      }
      return Tag;
    });
    var isCollapsed = props.isCollapsed;
    _this.state = {
      collapsed: Boolean(isCollapsed)
    };
    return _this;
  }
  _createClass(Card, [{
    key: "render",
    value: function render() {
      var collapsed = this.state.collapsed;
      /* eslint-disable no-unused-vars */
      var _this$props2 = this.props,
        id = _this$props2.id,
        title = _this$props2.title,
        content = _this$props2.content,
        onClick = _this$props2.onClick,
        imageSrc = _this$props2.imageSrc,
        imageAlt = _this$props2.imageAlt,
        expandableId = _this$props2.expandableId,
        actions = _this$props2.actions,
        isCollapsed = _this$props2.isCollapsed,
        className = _this$props2.className,
        titleHeadingLevel = _this$props2.titleHeadingLevel,
        elevation = _this$props2.elevation,
        children = _this$props2.children,
        spacing = _this$props2.spacing,
        href = _this$props2.href,
        custom = _this$props2.custom,
        nativeProps = _objectWithoutProperties(_this$props2, _excluded);
      /* eslint-enable no-unused-vars */
      var CardElementType = (custom === null || custom === void 0 ? void 0 : custom.component) || this.containerTag();
      return /*#__PURE__*/React.createElement(CardElementType, _extends({
        id: id,
        className: classNames('lm-Card', "lm-Card--".concat(elevation), {
          'lm-Card--is-collapsed': collapsed && !imageSrc && !onClick && !href
        }, {
          'lm-Card--media-object': imageSrc
        }, {
          'lm-Card--clickable': onClick || href
        }, {
          'lm-Card--spacing-none': spacing === 'none'
        }, {
          'lm-Card--spacing-compact': spacing === 'compact'
        }, className)
      }, custom && href && _defineProperty({}, (custom === null || custom === void 0 ? void 0 : custom.mapHrefToProp) || 'href', href), onClick && {
        onClick: onClick
      }, !custom && href && {
        href: href
      }, nativeProps), imageSrc && /*#__PURE__*/React.createElement("div", {
        className: "lm-Card-image-cell"
      }, /*#__PURE__*/React.createElement("img", {
        className: "lm-Card-image",
        src: imageSrc,
        alt: imageAlt || undefined
      })), /*#__PURE__*/React.createElement("div", {
        className: classNames({
          'lm-Card-body-cell': imageSrc
        })
      }, expandableId && !imageSrc && !onClick && !href && /*#__PURE__*/React.createElement("button", {
        "aria-label": "".concat(title, " expand button"),
        "aria-expanded": !collapsed,
        "aria-controls": expandableId,
        type: "button",
        className: "lm-Card-button-toggle",
        onClick: this.handleButtonCollapseClick
      }, /*#__PURE__*/React.createElement(IconCaretDown, {
        size: "16",
        ariaHidden: true
      })), title && this.renderTitle(), (content || children || actions) && /*#__PURE__*/React.createElement("div", {
        className: "lm-Card-body",
        id: expandableId || undefined,
        ref: this.expandableCardRef
      }, content && /*#__PURE__*/React.createElement("p", {
        className: "lm-Card-content"
      }, content), children && /*#__PURE__*/React.createElement("div", {
        className: "lm-Card-children"
      }, children), actions && !onClick && !href && /*#__PURE__*/React.createElement("div", {
        className: "lm-Card-actions"
      }, actions.map(function (action) {
        return action.type === 'link' ? /*#__PURE__*/React.createElement("span", {
          key: action.label,
          className: "lm-Card-link"
        }, action.label) : /*#__PURE__*/React.createElement(Button, {
          key: action.label,
          dynamicWidth: false,
          variant: action.variant ? action.variant : 'secondary',
          size: action.size ? action.size : 'small',
          onClick: action.onClick
        }, action.label);
      })))));
    }
  }]);
  return Card;
}(React.Component);
_defineProperty(Card, "propTypes", {
  /** Add an optional ID to an element with `class="lm-Card"`. */id: _pt.string,
  /** Card title heading. */title: _pt.string,
  /**
     * Which HTML element (e.g., h1, h2, h3, etc.) should be used for the title.
     * @default 'h2'
     */
  titleHeadingLevel: _pt.oneOfType([_pt.oneOf(['h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'span', 'div']), _pt.string]),
  /** Text for card body content. This will be rendered as a paragraph. */content: _pt.string,
  /** When an onClick event is passed into the card the entire card becomes clickable. */onClick: _pt.func,
  /** When an href is passed the entire card becomes a link */href: _pt.string,
  /** The card will have a media object layout (image on left, title and content on right)
    when an image src is passed into card. */
  imageSrc: _pt.string,
  /** Alternate text for the media object image. */imageAlt: _pt.string,
  /** Adds expandable toggle button when there's a prop value. This prop is required for aria-controls attribute. */expandableId: _pt.string,
  /** Loads card in collapsed state. */isCollapsed: _pt.bool,
  /** An array of buttons with.
     * actions={[
          { label?: 'Edit', size?: 'large', onClick?: () => alert('Edit button clicked') };
          { label?: 'Details', level?: 'primary', size?: 'large', onClick?: () => alert('Details button clicked') };
        ]}
    */
  actions: _pt.arrayOf(_pt.shape({
    label: _pt.string.isRequired,
    type: _pt.oneOf(['link', 'button', 'submit', 'reset']),
    onClick: _pt.func
  })),
  /** Use 'elevation' to adjust the shadow behind the card.
    @default 'flat'
    */
  elevation: _pt.oneOf(['flat', 'raised', 'floating']),
  /**
     * Spacing within card. When setting spacing to 'none', be sure to set any necessary margins or padding within the card content.
     * @default 'standard'
     * */
  spacing: _pt.oneOf(['standard', 'compact', 'none']),
  /** Add custom classes to an element with `class="lm-Card"`. */className: _pt.string,
  /** Any custom markup or components passed into card, rendered inside `<div className="lm-Card-children">`. */children: _pt.node,
  /* Set a custom component to render. For example, the Link component from react-router could be passed. This prop takes an object with two properties: 'component' and 'mapHrefToProp'. 'mapHrefToProp' is optional and specifies a target prop name. For example, when using react-router-dom, set 'mapHrefToProp' to 'to'. */custom: _pt.shape({
    component: _pt.any,
    mapHrefToProp: _pt.string
  })
});
_defineProperty(Card, "defaultProps", {
  titleHeadingLevel: 'h2',
  elevation: 'flat'
});